{
  "publicConsents": {
    "brandSubtitle": "Consent station · reception",
    "footerDataController": "Data controller",
    "footerDpoLabel": "DPO",
    "loading": "Loading…",

    "headerRefresh": "Refresh",
    "headerRefreshing": "Checking…",
    "headerRelease": "Release the tablet",
    "headerConfigure": "Configuration",
    "headerLogout": "Sign out",

    "waitingEyebrow": "The tablet is ready",
    "waitingTitleLine1": "Waiting for",
    "waitingTitleLine2": "a patient",
    "waitingRegisteredAs": "This tablet is registered as",
    "waitingRefreshHintBefore": "Once reception sends a patient to this tablet, press",
    "waitingRefreshHintAfter": "in the top bar to load the documents.",
    "waitingNoPatientYet": "No patient is assigned to this tablet yet.",
    "waitingReleasing": "Releasing…",
    "waitingReleaseRetry": "Try releasing again",
    "waitingChangeDevice": "Change the tablet",

    "setupEyebrow": "Configuration",
    "setupLocationTitleLine1": "Choose",
    "setupLocationTitleLine2": "the location",
    "setupLocationLead": "Select the location this tablet is in. Only the tablets from the chosen location will be listed.",
    "setupDeviceTitleLine1": "Choose",
    "setupDeviceTitleLine2": "this tablet",
    "setupDeviceLead": "Select the tablet that matches this device. The choice is remembered on this device until you change it.",
    "setupLocationLabel": "Location",
    "setupDeviceLabel": "Tablet",
    "setupDevicesLoading": "Loading the tablet list…",
    "setupNoDevices": "No tablets are configured. Add one under Structure → Settings → IT devices.",
    "setupUnnamedLocation": "Unnamed location",
    "setupConfirm": "Confirm",
    "setupChangeLocation": "Change the location",

    "codeEyebrow": "Hello,",
    "codeTitleLine1": "Enter the",
    "codeTitleLine2": "session code",
    "codeLead": "To open the documents prepared for you, enter the unique 6-character code you were given.",
    "codeLabel": "Session code",
    "codeCharAriaLabel": "Character {{position}}",
    "codeNote": "The code is unique, valid for 30 minutes and can be used only once. The session is encrypted.",
    "codeContinue": "Continue",
    "codeHelpTitle": "No code?",
    "codeHelpBody": "The session code is given to you by reception when you check in.",

    "welcomeEyebrow": "Hello,",
    "welcomeLead": "On this tablet you can read and sign the consents needed to continue your medical care. Please read each document carefully before signing it.",
    "welcomeIdentityConfirmed": "Identity confirmed",
    "welcomeSessionOpen": "Session open",
    "welcomeSessionStation": "Reception consent station",
    "welcomeSessionOpenedAt": "at {{time}}, today",
    "welcomeToReviewCount": "You have {{count}} consents to review",
    "welcomeOptionalSuffix": " · optional",
    "welcomeNote": "The process takes about 5 minutes. The signing details (date, time, identity) will be recorded in your medical record in line with GDPR Art. 7.",
    "welcomeStart": "Start the review",

    "consentProgressOf": " of ",
    "consentScopeFallback": "Consent",
    "consentBack": "Back",
    "consentDocRead": "Whole text read",
    "consentDocScroll": "Scroll to read the whole text",
    "consentPurposesLabel": "Processing purposes",
    "consentPurposeMandatory": "mandatory",
    "consentAgreeText": "I have read and understood the text above and I give my consent freely.",
    "consentAgreeSub": "Tick it yourself — GDPR Art. 7 does not allow pre-ticked boxes.",
    "consentSignatureLabel": "Your signature",
    "consentSignatureClear": "Clear and redo",
    "consentSignaturePlaceholder": "Sign with your finger or the tablet pen",
    "consentSignatureCaptured": "✓ Signature captured",
    "consentRefuse": "I refuse this consent",
    "consentFootIdentityBefore": "The consent will be recorded under the identity of the account",
    "consentFootIdentityAfter": ", at the current date and time.",
    "consentFootWithdraw": "You can withdraw your consent at any time, through reception or from the patient portal.",
    "consentNextFinish": "Finish",
    "consentNextOne": "Next consent",
    "consentFormGenerated": "Form generated",
    "consentFormGeneratedOn": "Form generated {{date}}",

    "summaryEyebrow": "Summary",
    "summaryTitleLine1": "All the documents",
    "summaryTitleLine2": "have been reviewed.",
    "summarySignedBy": "Signed by",
    "summaryEditAgain": "I want to change something",
    "summaryFinish": "Submit and hand the tablet back",

    "handbackThanks": "Thank you,",
    "handbackLead": "Your consents have been recorded in your medical record.",
    "handbackNote": "Please hand the tablet back to reception.",
    "handbackNewSession": "New session",

    "statusRevoked": "Revoked",
    "statusActive": "Active",
    "statusToSign": "To sign",
    "statusRefused": "Refused",
    "statusSigned": "Signed",
    "statusSignedAt": "Signed {{time}}",

    "patientIdNumberLabel": "CNP",
    "patientBornPrefix": "b.",
    "patientAgeYears": "{{count}} years",

    "errorStoredDeviceInactive": "The remembered tablet is no longer active. Choose a tablet from the list.",
    "errorDevicesLoad": "The tablet list could not be loaded. Reload the page.",
    "errorCheckFailed": "The check failed. Try again or tell reception.",
    "errorReleaseFailed": "The tablet could not be released. Try again before handing it to another patient.",
    "codeValid": "✓  Code valid. Loading your session…",
    "codeInvalid": "✕  Invalid or expired code. Check the code you were given and try again.",
    "refuseConfirm": "Are you sure you refuse this consent? You can carry on with the other documents."
  }
}
